import React from 'react';

import SocialLink from './Social';
import InstagramIcon from '../icons/Instagram';

import classes from '../Footer.scss';

export default function InstagramLink(props) {
  return (
    <SocialLink
      href  = "https://www.instagram.com/cityads_media/"
      title = "Instagram"
      {...props}
    >
      <InstagramIcon className={classes.socialIcon} />
    </SocialLink>
  );
}